/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { useCurrentUser } from "src/app/useCurrentUser";
import { BaseUser } from "src/classes/user";
import { FollowButton } from "src/components/Profile/FollowButton";
import { Avatar } from "src/components/Shared/User/Avatar";
import { Username } from "src/components/Shared/User/Username";
import { UnstyledLink } from "src/components/UI/Links/Links";

interface Props {
  user: BaseUser;
}

export function SuggestedUserSmall({ user }: Props) {
  const currentUser = useCurrentUser();

  return (
    <UnstyledLink href={user.inAppLink}>
      <SidePanelItemWrapper key={user.snapshot.username}>
        <Avatar src={user.avatarURL(48)} size={48} />
        <UserInfoContainer>
          {user.snapshot.displayName}
          <br />
          <Username hoverable user={user} />
        </UserInfoContainer>
        {/* logged out people can't see button */}
        {currentUser && (
          <div style={{ alignSelf: "center" }}>
            <FollowButton user={user} />
          </div>
        )}
      </SidePanelItemWrapper>
    </UnstyledLink>
  );
}

const UserInfoContainer = styled.div`
  margin-left: 15px;
  flex-grow: 1;
  user-select: none;
  color: ${({ theme }) => theme.text.default};
`;

const SidePanelItemWrapper = styled.div`
  display: flex;
  font-family: "Inter", sans-serif;
  margin-top: 15px;
  margin-bottom: 15px;
  width: 320px;
`;
